import React, { useContext, useEffect, useState } from 'react'
import ButtonBlack from '../../../../components/Buttons/ButtonBlack'
import { BiDownload } from 'react-icons/bi'
import ConfirmModal from "../../../../components/Modal/ConfirmModal"
import Modal from '../../../../components/Modal'
import TextAreaEditor from '../../../../components/Form/TextAreaEditor'
import { CgClose } from 'react-icons/cg'
import Input from '../../../../components/Form/Input'
import Select from '../../../../components/Form/Select'
import ImagePicker from "../../../../components/ImagePicker"
import image1 from "../../../assets/images/gabrielle-henderson-DgCPTkDqhHg-unsplash.jpg"
import imagefile from "../../../../plateform/assets/icons/paperclip-svgrepo-com.svg"
import FilePicker from "../../../../components/FilePicker"
import axios from 'axios'
import Invoice from '../../../../ui/Invoice'
import {plansData as plansDatas} from "../../../datas/PlanData"
import { api } from '../../../../../api'
import { useSelector } from 'react-redux'
import {formatDate} from "../../../../components/DateTimeConverter/DateTimeConverter"
import { useOutletContext } from 'react-router-dom'
import ButtonDanger from '../../../../components/Buttons/ButtonDanger'
import MultiSelect from '../../../../components/Form/Select/MultiSelect'

const Abonnement = () => {
  const [showModal, setShowModal] = useState(false)
  const [showAddModal, setShowAddModal] = useState(false)
  const [showCancelPlanModal, setShowCancelPlanAddModal] = useState(false)
  const [subscriptionData, setSubscriptionData] = useState({
    object: '',
    type: 'Standard',
    message: '',
    file: null,
    transaction_id: ""
  })
  const { user } = useSelector((store) => store.user);
  const [currentSubscription, setCurrentSubscription] = useState(null)
  const [nextSubscription, setNextSubscription] = useState(null)
  const [plansData, setPlansData] = useState([])
  const {showNotif, setShowNotif} = useOutletContext()
  const [loading, setloading] = useState(false)

  // Fetch current subscriptions and all available plans from API
  useEffect(() => {
    const fetchSubscriptionData = async () => {
      try {
        const response = await axios.get(api+'/subscriptions/current/'+2) // A MODIFIER: user.id API endpoint to fetch current subscription
        setCurrentSubscription(response.data.currentSubscription)
        setNextSubscription(response.data.nextSubscription)
      } catch (error) {
        console.error("Error fetching subscription data:", error)
      }
    }

    const fetchPlansData = async () => {
      try {
        const response = await axios.get(api+'/subscriptions/user/'+2) // A MODIFIER: user.id API endpoint to fetch all available plans
        setPlansData(response.data)
      } catch (error) {
        console.error("Error fetching plans data:", error)
      }
    }

    fetchSubscriptionData()
    fetchPlansData()
  }, [])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setSubscriptionData({ ...subscriptionData, [name]: value })
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Récupérer le fichier
    if (file) {
      setSubscriptionData((prevValues) => ({ ...prevValues, file: file }));
    }
  }

  const handlePayment = async () => {
    setloading(true)
    const formData = new FormData()
    formData.append('user_id', 2) //A MODIFIER user?.id
    formData.append('object', subscriptionData.object)
    formData.append('price', plansDatas.filter((item)=> item.name === formData?.plan )[0]?.price || 2000)
    formData.append('plan', subscriptionData.type)
    formData.append('message', subscriptionData.message)
    formData.append('transaction_id', subscriptionData.transaction_id)
    
    if (subscriptionData.file) formData.append('file', subscriptionData.file)
// console.log(subscriptionData)
      // formData.forEach((el, index)=>console.log("Saisie",el, index))
  
       await axios.post(api+'/subscriptions/'+2+'/renew', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((response)=>{
        console.log('Paiement réussi: ' + response.data)
        setloading(false)

        setShowAddModal(false)
        setSubscriptionData([...subscriptionData, response.data?.subscription])
        setShowNotif({...showNotif, variant: "success", message:"Connexion réussie !", show: true})
      })
     
    .catch( (error) =>{
      console.error('Erreur de paiement:', error)
      setloading(false)
      // alert('Paiement échoué. Veuillez réessayer.')
      setShowNotif({...showNotif, variant: "danger", message:"Une erreur est survenue", show: true})
    })
  }

  // const handleRenewal = async () => {
  //   try {
  //     const response = await axios.post(api+'/subscriptions/renew', { plan: nextSubscription.name })
  //     alert('Abonnement renouvelé avec succès.')
  //     setCurrentSubscription(response.data.updatedSubscription)
  //   } catch (error) {
  //     console.error('Erreur de renouvellement:', error)
  //     alert('Renouvellement échoué. Veuillez réessayer.')
  //   }
  // }

  const handleCancelSubscription = async () => {
    setloading(true)
   
      await axios.post(api+'/subscriptions/cancel', { subscriptionId: currentSubscription.id })
      .then((response)=>{
        setloading(false)
        alert('Abonnement annulé avec succès.')
        setCurrentSubscription(null) // Clear current subscription after cancellation
        setShowNotif({...showNotif, variant: "success", message:"Connexion réussie !", show: true})    

      })
      .catch ((error) =>{
      setShowNotif({...showNotif, variant: "danger", message:"Une erreur est survenue", show: true})
      console.error('Erreur d\'annulation:', error)
    })
  }

  return (
    <div className='layout-1 text-sm'>
      <div className="grid grid-cols-2 gap-4">
        <div className='gap-y-4 space-y-4 line-border'>
          <div className=' h-full pb-6 '>
            <h5 className='font-semibold'>Abonnement actuel</h5>
            {currentSubscription ? (
              <div className=" h-full flex flex-col justify-between items-start">
                <div className='space-y-2'>
                  <h5 className='font-semibold text-lg'>{currentSubscription?.plan}</h5>
                  <div>Date d'activation: {formatDate(currentSubscription.activated_at)}</div>
                  <div>Date d'expiration: {formatDate(currentSubscription.expired_at)}</div>
                  <div>Mode de paiement: {formatDate(currentSubscription.expired_at)}</div>
                  <p className='text-primary-text'>{currentSubscription?.description}</p>
                </div>
                
                <div className='grid grid-cols-2 gap-4 w-full'>
                  <ButtonBlack onClick={() => setShowAddModal(true)}>Renouveller</ButtonBlack>
                  <button
                    className='px-6 py-2 rounded-md bg-neutral-50 hover:bg-neutral-100'
                    onClick={() => setShowCancelPlanAddModal(true)}
                  >
                    Annuler
                  </button>  
                </div>
              </div>
            ) : (
              <p>Aucun abonnement actif</p>
            )}
          </div> 

          {/* Section Prochain Abonnement */}
          {nextSubscription && (
            <div className='line-border space-y-2'>
              <h5 className='font-semibold'>Prochain abonnement</h5>
              <h5 className='font-semibold text-lg'>{nextSubscription.price}</h5>
              <div>Date prévue d'activation: {nextSubscription.activationDate}</div>
              <p className='text-primary-text'>{nextSubscription.description}</p>
              <ButtonBlack onClick={() => setShowAddModal(true)}>Payer maintenant</ButtonBlack>
            </div>
          )}
        </div>

        {/* Section Fonctionnalités */}
        <div className='line-border space-y-2'>
          <h5 className='font-semibold'>Fonctionnalités</h5>
          <h5 className='font-semibold text-lg'>{currentSubscription?.price}</h5>
          <div>Date d'activation: {nextSubscription?.activationDate}</div>
          <p className='text-primary-text'>{currentSubscription?.description}</p>
          <hr />
          <ul className="mt-4 space-y-3">
            {plansDatas.filter((item)=> item.name === currentSubscription?.plan )[0]?.features?.map((feature, index) => (
              <li key={index} className="flex space-x-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-5 w-5 text-neutral-900" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M5 12l5 5l10 -10"></path>
                </svg>
                <span className="text-start">{feature}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="overflow-auto py-4 w-full">
        <table className="w-full">
          <thead className='text-sm'>
            <tr className="text-left bg-neutral-100 py-3 rounded-sm">
              <th className="pl-5 bg-neutral-100 py-3 rounded-sm ">ID</th>
              <th className="pl-5 bg-neutral-100 py-3 rounded-sm">Date d'activation</th>
              <th className="pl-5 bg-neutral-100 py-3 rounded-sm">Date d'éxpiration</th>
              <th className="pl-5 bg-neutral-100 py-3 rounded-sm">Plan</th>
              <th className="pl-5 bg-neutral-100 py-3 rounded-sm">Prix</th>
              <th className="pl-5 bg-neutral-100 py-3 rounded-sm">Etat</th>
              <th className="pl-5 bg-neutral-100 py-3 rounded-sm">Action</th>
            </tr>
          </thead>
          <tbody>
            {plansData?.map((item) => (
              <tr key={item.id} className="border-b border-gray-100 rounded text-start">
                <td className="pl-5 py-3">#{item.id}</td>
                <td className="pl-5">{item.validated_at ? formatDate(item.validated_at) : "-"}</td>
                <td className="pl-5">{formatDate(item.expired_at)}</td>
                <td className="pl-5">{item.plan}</td>
                <td className="pl-5">{item.price}</td>
                <td className="pl-5">{item.status}</td>
                <td className="pl-5">
                  <Invoice planSelected={item}></Invoice>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

   

      <ConfirmModal setIsOpen={() => setShowModal(false)} isOpen={showModal} onConfirm={handleCancelSubscription} />
        <Modal isOpen={showAddModal} onClose={() => setShowAddModal(false)}>
          <div className="flex items-center justify-between py-2 px-4">
            <p>Payer un abonnement</p>
            <button onClick={() => setShowAddModal(false)} className='px-2 py-2 rounded-md border text-primary-black'>
              <CgClose />
            </button>
          </div>
          <hr className='mb-6' />
          <div className="px-6 space-y-4 mb-4">
            <Input label="Objet" name="object" value={subscriptionData.object} onChange={handleInputChange} />
            <Select label="Type d'abonnement" options={["Standard", "Professionnel", "Prémium"]} name="type" value={subscriptionData.type} onChange={handleInputChange} />
            <Input label="Numéro de la transaction" name="transaction_id" value={subscriptionData.transaction_id} onChange={handleInputChange} />
            <TextAreaEditor label='Message' name="message" value={subscriptionData.message} setValue={(value)=>setSubscriptionData({ ...subscriptionData, message: value })} />
            <FilePicker handleChange={handleFileChange} />
          </div>
          <div className="flex items-center justify-end p-6">
            <ButtonBlack isLoading={loading} onClick={handlePayment} className="py-2 px-6 rounded-sm shadow bg-primary-black text-white">
              Enregistrer
            </ButtonBlack>
          </div>
        </Modal>

        <Modal isOpen={showCancelPlanModal} onClose={() => setShowCancelPlanAddModal(false)}>
          <div className="flex items-center justify-between py-2 px-4">
            <p>Annuler un abonnement</p>
            <button onClick={() => setShowCancelPlanAddModal(false)} className='px-2 py-2 rounded-md border text-primary-black'>
              <CgClose />
            </button>
          </div>
          <hr className='mb-6' />
          <div className="px-6 space-y-4 mb-4">
            <Input label="Objet" name="object" value={subscriptionData.object || "Remboursement"} onChange={handleInputChange} />
            <MultiSelect
  label="Raison"
  options={[
    { value: "trop_cher", label: "Trop cher" },
    { value: "peu_utilisé", label: "Peu utilisé" },
    { value: "service_insatisfaisant", label: "Service insatisfaisant" },
    { value: "trouvé_meilleure_offre", label: "J'ai trouvé une meilleure offre" },
    { value: "besoin_termine", label: "Je n'en ai plus besoin" },
    { value: "support_insatisfaisant", label: "Support client insatisfaisant" },
    { value: "problemes_techniques", label: "Problèmes techniques fréquents" },
    { value: "autre", label: "Autre" }
  ]}
  name="type"
  value={subscriptionData.type}
  onChange={handleInputChange}
/>
            <TextAreaEditor label='Message' name="message" value={subscriptionData.message} setValue={(value)=>setSubscriptionData({ ...subscriptionData, message: value })} />
          </div>
          <div className="flex items-center justify-end p-6">
            {/* <button onClick={handlePayment} className="py-2 px-6 rounded-sm shadow bg-red-500 text-white">
              
            </button> */}
            <ButtonDanger isLoading={loading} onClick={handlePayment} className = 'px-6 py-2 rounded-sm'>Confirmer</ButtonDanger>
          </div>
        </Modal>
    </div>
  )
}

export default Abonnement
